// extracted by mini-css-extract-plugin
module.exports = {"Admin":"_2HpIUqt1","content":"_1g9gM3bI"};